import { LOGGER_URL } from 'constants/config';
import { fetchJson } from 'utils/fetchJson/fetchJson';

const logger = {
  log: async ({
    description,
    parameters,
  }: {
    description: string;
    parameters?: object;
  }) => {
    const path = `${LOGGER_URL}`;
    const body = JSON.stringify({ description, parameters });

    const options = { body, method: 'POST' };

    try {
      await fetchJson(path, options);
    } catch (error) {
      console.error(error);
    }
  },
};

export { logger };
